export default __webpack_public_path__ + "static/media/icon-integrity.98783ae4.svg";